// Dateien öffnen (Import, Logo) und herunterladen (Exporte).
import { migrate } from './migrate.js';
import { checkIntegrity } from './integrity.js';


export function download(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function safeName(s) {
  return String(s || 'projects').replace(/[\\/:*?"<>|]+/g, '').replace(/\s+/g, '_').slice(0, 80);
}

/** Liest eine Datei, prüft sie und gibt migrierte Daten zurück. */
export async function parseFile(file) {
  const text = await file.text();
  let raw;
  try {
    raw = JSON.parse(text);
  } catch {
    throw new Error('Die Datei ist kein gültiges JSON.');
  }
  const data = migrate(raw);
  const errs = checkIntegrity(data);
  if (errs.length) throw new Error('Die Datei enthält fehlerhafte Bezüge:\n' + errs.slice(0, 8).join('\n'));
  return data;
}

/** Datei auswählen. Gibt { file } zurück oder null bei Abbruch. */
export function pickFile(accept = '.json') {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = () => resolve(input.files[0] ? { file: input.files[0] } : null);
    input.click();
  });
}

/** Liest eine Bilddatei als Data-URI und ermittelt das Seitenverhältnis. */
export function readImage(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const img = new Image();
      img.onload = () => resolve({ src: r.result, ratio: img.naturalWidth / img.naturalHeight || 2 });
      img.onerror = () => reject(new Error('Bild konnte nicht gelesen werden.'));
      img.src = r.result;
    };
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });
}
